import angular from "angular";

let HomeAppController = function (
  $filter,
  $mdDialog,
  $scope,
  $state,
  $timeout,
  Page,
  Toast
) {
  let $ctrl = this;
  angular.extend($ctrl, {
    save,
    removeImg
  });

  $ctrl.saving = false;
  $ctrl.data = {
    title: "",
    status: false,
    urlImage: "",
  };

  function activate() {
    $ctrl.saving = true;
    Page.getImg()
      .then((response) => {
        if (response) $ctrl.data = angular.copy(response);
        else {
            $ctrl.data = {
                title: "",
                is_active: false,
                image_url: "",
              };
        }
        $ctrl.saving = false;
      })
      .catch((err) => {
        $ctrl.saving = false;
      });
  }

  function save() {
    $ctrl.saving = true;
    Page.saveImg($ctrl.data)
      .then((response) => {
        Toast.success("Dados da imagem salvos com sucesso");
        $ctrl.saving = false;
        activate()
      })
      .catch((err) => {
        Toast.error($filter("translate")("common-save-error"));
        $ctrl.saving = false;
      });
  }

  function removeImg(data) {
    let confirm = $mdDialog.confirm()
      .textContent(`Deseja remover essa imagem`)
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        Page
          .deleteImg(data)
          .then(response => {
            Toast.success("Imagem removida com sucesso");
            activate()
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
          });
      })
      .catch(() => {
      });
  }


  activate();
};

HomeAppController.$inject = [
  "$filter",
  "$mdDialog",
  "$scope",
  "$state",
  "$timeout",
  "Page",
  "Toast",
];

export default HomeAppController;



// WEBPACK FOOTER //
// ./client/app/components/page/page-home-app.controller.js